import axios from "axios";
import {
  REMOVE_TOKEN,
  SET_TOKEN,
} from "../Components/Views/AuthModule/services/authReducer";
import TokenPersistenceManager from "./tokenPersistenceManager";
import store from "../store/store";
import api from "./api";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

api.interceptors.request.use(config => {
  const token = store.getState().auth.token;

  if (!token) return config;

  if (!config.headers) config.headers = {};

  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

api.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            return api(originalRequest);
          })
          .catch(err => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshToken = TokenPersistenceManager.getRefreshToken();
        const response = await api.post("/auth/store/refresh-token", {
          refreshToken,
        });
        const { accessToken } = response.data;

        TokenPersistenceManager.setToken(accessToken);
        store.dispatch(SET_TOKEN({ token: accessToken }));

        processQueue(null, accessToken);
        return api(originalRequest);
      } catch (err) {
        processQueue(err, null);
        TokenPersistenceManager.removeToken();
        store.dispatch(REMOVE_TOKEN());
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  },
);
